import { Button, Tooltip } from 'shared-ui';

import { ReactComponent as BlockIcon } from 'assets/icons/block.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';
import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { Functionality } from 'api/userPermissions/userPermissions.enum';

import { UnblockMultiCardsProps } from './UnblockMultiCards.types';

export const UnblockMultiCards = ({
  checkedCards,
  isModalOpen,
  onSubmit,
  isLoading,
  onModalClose,
  onModalOpen,
}: UnblockMultiCardsProps) => {
  const { formatMessage } = useLocale();
  const { perms } = usePermissions();
  const isDisabled = !perms?.[Functionality.KARTY_POSIADACZE]?.edit;

  return (
    <>
      <Tooltip title={formatMessage({ id: AppMessages['common.noPermissions'] })} disableHoverListener={!isDisabled}>
        <Button
          variant="outlined"
          color="primary"
          size="medium"
          startIcon={
            <BlockIcon style={{ filter: isDisabled ? 'grayscale(1)' : 'none', opacity: isDisabled ? 0.5 : 1 }} />
          }
          onClick={onModalOpen}
          disabled={isDisabled}
        >
          {formatMessage({ id: AppMessages['cards.multiAction.unblock.button'] })}
        </Button>
      </Tooltip>

      <ActionModal
        header={formatMessage({ id: AppMessages['cards.multiAction.unblock.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        onSubmit={onSubmit}
        submitButtonDisabled={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['cards.multiAction.unblock.button'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['cards.multiAction.unblock.subtitle'] })} {checkedCards.length}
        </ActionModal.Subtitle>

        <ActionModal.Text>{formatMessage({ id: AppMessages['cards.multiAction.unblock.text'] })}</ActionModal.Text>

        <ActionModal.Text>{formatMessage({ id: AppMessages['common.reversibleAction'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
